import React from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import { uniqueId } from "lodash";
import { Placeholder, Row } from "react-bootstrap";
import { StarRating } from "@components";
import { ProgressBar } from "./ProgressBar";
import styles from "./styles/ReviewSummary.module.css";
import { formatNumberText } from "@helpers";

const ReviewSummary = (props) => {
  const {
    title,
    numRating,
    ratingList,
    subTitle,
    totalReviews,
    processing,
    onChange,
    ratingSelected,
  } = props;

  if (processing) {
    return (
      <Placeholder animation="glow">
        <div className={clsx(styles.container, "border rounded p-4")}>
          <h5>{title}</h5>
          <Row className="g-3">
            <Placeholder xs={12} size="lg" />
            <Placeholder xs={12} className={styles.summaryPlaceholder} />
          </Row>
        </div>
      </Placeholder>
    );
  }

  const ratingListReverse = ratingList
    ? [
        ...ratingList.map((r, index) => ({
          rate: r.toFixed(),
          star: index + 1,
        })),
      ].reverse()
    : [];

  return (
    <div className={clsx(styles.container, "border rounded p-4")}>
      <h5>{title}</h5>
      <div
        className={clsx(
          "border rounded d-flex flex-wrap align-items-center py-2 px-3 mt-3",
          styles.averageRateContainer
        )}
      >
        {Number.isInteger(numRating) ? numRating : numRating.toFixed(1)}
        <StarRating numRating={numRating} />
        <span className="h6 m-0">{subTitle}</span>
        <span>({formatNumberText(totalReviews, "review")})</span>
      </div>
      <div>
        {ratingListReverse.map((rating) => {
          if (+rating.rate == 0) return null;
          return (
            <div
              key={uniqueId()}
              className={clsx(
                "row mt-3 align-items-center",
                styles.ratingItem,
                rating.star !== ratingSelected && "opacity-25",
                ratingSelected === 0 && "opacity-100"
              )}
              onClick={() => onChange(rating.star)}
            >
              <div className="col ">
                <ProgressBar value={rating.rate} />
              </div>
              <div className="col d-flex align-items-center">
                <StarRating numRating={rating.star} />
                <span className={clsx("ml-3", styles.ratingNumber)}>
                  {rating.rate}%
                </span>
              </div>
            </div>
          );
        })}

        {ratingSelected !== 0 && (
          <button className={styles.btnShowAll} onClick={() => onChange(0)}>
            Show all
          </button>
        )}
      </div>
    </div>
  );
};

/* required: display name */
ReviewSummary.displayName = "ReviewSummary";

/* required: props types */
ReviewSummary.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  numRating: PropTypes.number,
  ratingList: PropTypes.arrayOf(PropTypes.number),
  totalReviews: PropTypes.number,
  processing: PropTypes.bool,
  onChange: PropTypes.func,
  ratingSelected: PropTypes.number,
};

/* required: default props */
ReviewSummary.defaultProps = {
  title: "Student Feedback",
  subTitle: "Course Rating",
  numRating: 0,
  ratingList: [],
  totalReviews: 0,
  processing: false,
  onChange: () => {},
  ratingSelected: 1,
};

export { ReviewSummary };
